import { useAppSelector, useAppDispatch } from 'store/hook';
import React, { useEffect } from 'react';
import { RootState } from 'store';
import Storage from 'utils/storage';
import { useTranslation } from 'react-i18next';
import { ConfigProvider } from 'antd';
import { getUserDetail } from 'controller/auth';
import { SET_USER_INFO } from 'store/userReducer';
import './i18n/config';
import 'react-photo-view/dist/react-photo-view.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import enUS from 'antd/locale/en_US';
import zhCN from 'antd/locale/zh_CN';
import zhTw from 'antd/locale/zh_TW';
import GoogleAuth from 'ui-component/googleAuth';
import ValidatePassword from 'ui-component/verifyPassword'
import Kyc from 'ui-component/kyc'
import { initFingerprint } from 'utils/request';

// routing
import Routes from 'routes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import { LANGUAGE } from 'constants/common';
import Websocket from 'ui-component/websocket';

const App = () => {
  const { i18n } = useTranslation();
  const loading = useAppSelector((state: RootState) => state.user.loading);
  const payment = useAppSelector((state: RootState) => state.user.payment);
  const openKyc = useAppSelector((state: RootState) => state.user.openKyc);

  const dispatch = useAppDispatch();

  // useEffect(() => {
  //   initFingerprint(); // 页面加载就先获取并缓存
  // }, []);

  useEffect(() => {
    const LANGUAGES = ['en', 'zh'];
    const navigatorLan = navigator.language.split('-')[0];
    const defaultLan = (LANGUAGES.includes(navigatorLan) && navigatorLan) || 'en';
    const currentLan = Storage.get(LANGUAGE, defaultLan, true);
    i18n.changeLanguage(currentLan);
  }, [i18n]);

  useEffect(() => {
    const getData = async () => {

      dispatch(
        SET_USER_INFO({
          loading: true
        })
      );
      await initFingerprint()
  
      // @ts-ignore
      if (window.location.pathname === '/begin' || window.location.pathname === '/login' || window.location.pathname === '/register') {
        dispatch(
          SET_USER_INFO({
            loading: false
          })
        );
        // @ts-ignore
        if (!document.tidioIdentify) {
          // @ts-ignore
          document.tidioIdentify = {
            name: '登录页游客'
          };
          setTimeout(() => {
            const tidioScript = document.createElement('script');
            tidioScript.src = '//code.tidio.co/vghsf5l1zo1w5u2adhzakpi7rjygoy2p.js';
            document.body.appendChild(tidioScript);
          }, 0);
        } else {
          // @ts-ignore
          if (window.tidioChatApi) {
            // @ts-ignore
            window.tidioChatApi.display(true);
          }
        }
        return;
      }
      Promise.all([getUserDetail()]).then(() => {
        dispatch(
          SET_USER_INFO({
            loading: false
          })
        );
      });
    }
    getData()
   
  }, [dispatch]);

  if (loading) return <div style={{ position: 'fixed', top: '10px', left: 0, right: 0, bottom: 0, backgroundColor: '#fff' }} />;

  return (
    <ConfigProvider
      locale={i18n.language === 'zh' ? zhCN : i18n.language === 'mo' ? zhTw : enUS}
      theme={{
        token: {
          colorPrimary: 'rgba(22, 119, 255, 1)',
          colorText: '#000000',
          colorTextSecondary: 'rgba(0,0,0, 0.65)',
          colorTextTertiary: 'rgba(0,0,0, 0.45)',
          colorTextQuaternary: 'rgba(0,0,0, 0.25)',
          colorSuccessBorder: '#BAE0FF',
          colorInfo: 'rgba(22, 119, 255, 1)',
          colorTextBase: '#000000',
          borderRadius: 4
        },
        components: {
          Typography: {
            colorTextDescription: 'rgba(11,37,86, 0.65)'
          },
          Breadcrumb: {
            itemColor: 'rgba(11,37,86, 0.45)',
            lastItemColor: 'rgba(11,37,86)',
            separatorColor: 'rgba(11,37,86, 0.45)',
            iconFontSize: 20,
            linkColor: 'rgba(11,37,86, 0.45)',
            fontSize: 20,
            fontSizeIcon: 16
          },
          Dropdown: {
            borderRadiusLG: 6,
            colorTextDisabled: 'rgba(11,37,86, 0.25)'
          },
          Menu: {
            dropdownWidth: 200,
            itemBorderRadius: 6,
            itemColor: '#000000',
            itemHoverColor: '#000000',
            horizontalItemHoverColor: 'rgba(22, 119, 255, 1)',
            groupTitleColor: 'rgba(11,37,86, 0.45)',
            itemSelectedColor: 'rgba(22, 119, 255, 1)',
            horizontalItemSelectedColor: 'rgba(22, 119, 255, 1)',
            itemActiveBg: '#E5EEFF',
            itemSelectedBg: '#E5EEFF',
            iconSize: 16,
            groupTitleFontSize: 12
          },
          Tag: {
            borderRadiusSM: 4,
            fontSize: 12
          },
          Modal: {
            padding: 24
          },
          Input: {
            borderRadius: 4
          },
          Select: {
            borderRadius: 4
          },
          Button: {
            borderRadius: 4
          },
          Tooltip: {
            colorBgSpotlight: '#7A7A7A',
            fontSize: 12
          }
        }
      }}
    >
      <NavigationScroll>
        <Routes />
        <Websocket />
        <GoogleAuth />
        <Kyc open={openKyc} />
        {payment.openConfirmPayment && <ValidatePassword open={payment.openConfirmPayment} />}
      </NavigationScroll>
    </ConfigProvider>
  );
};

export default App;
